import { render } from "./ModalDeleteConfirmation.vue?vue&type=template&id=ae35a9c0&scoped=true"
import script from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js"

import "./ModalDeleteConfirmation.vue?vue&type=style&index=0&id=ae35a9c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae35a9c0"]])

export default __exports__